import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IItemsInRowComponentProps } from '../components/items-in-row/items-in-row';

export class ItemsInRowModel extends ContentItem {
  get children(): IKontentItem[] {
    return get(this._config, 'elements.items_to_present.value', []);
  }

  get additionalStyle(): string {
    return get(
      this._config,
      'elements.margin_between_items__choose.value[0].codename',
      ''
    );
  }

  get aligment(): string {
    const getAligment = get(
      this._config,
      'elements.items_aligment.value[0].codename',
      ''
    );

    switch (getAligment) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  }

  public static create(data: IItemsInRow): IItemsInRowComponentProps {
    const { children, additionalStyle, aligment } = new ItemsInRowModel(data);
    return {
      children,
      additionalStyle,
      aligment
    };
  }
}
